import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    OrderStatuses, OrderTypes, ProductType,
} from 'app/enums/label.enums'

import {
    InboundOrdersType,
} from '../ScenarioEditor.types'

const config: SkyNetTableConfig<keyof InboundOrdersType> = {
    name: 'InboundOrders',
    fields: [
        {
            name: 'orderNumber',
            width: '160px',
            labelKey: 'ORDER',
            componentName: 'OrderTableLink',
        },
        {
            name: 'orderStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderStatuses,
            filterField: 'orderStatus',
            filterType: FilterType.Array,
            labelKey: 'ORDER_STATUS',
        },
        {
            name: 'orderType',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderTypes,
            labelKey: 'ORDER_TYPE',
            filterField: 'orderType',
            filterType: FilterType.Array,
        },
        {
            name: 'from',
            labelKey: 'FROM',
        },

        {
            name: 'originLocationLocationName',
            filterField: 'originLocationLocationName',
            filterType: FilterType.Array,
            labelKey: 'ORIGIN_LOCATION',
        },
        {
            name: 'estimatedArrival',
            sorting: false,
            labelKey: 'ESTIMATED_DELIVERY',
        },
        {
            name: 'requiredContainers',
            componentName: 'RequiredContainersList',
            allowedValuesEnum: ProductType,
            sorting: false,
            labelKey: 'REQUIRED_CONTAINERS',
            filterField: 'requiredContainers',
            filterType: FilterType.Array,
        },
    ],
}

export default config
